/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import React, { Element, Modern, useFlux } from 'fierry/react.old';

import Command from 'shared/client/command';

import Info from 'svg/shared/modern/info';
import Error from 'svg/shared/modern/error';


const Component = ({ icon, text }) =>
(
  <Modern.Card>
    <Element.Group param >

      <Element.Icon value = {icon} />
      <Element.Text value = {text} />

    </Element.Group>
  </Modern.Card>
);


export default (props) =>
{
  const [ command ] = useFlux(Command);

  if (command.isInitial())
  {
    return <Component icon = {<Info />} text = {command.getInitial()} />;
  }

  if (command.isError())
  {
    return <Component icon = {<Error />} text = {command.getError()} />;
  }

  if (command.getInfo())
  {
    return <Component icon = {<Info />} text = {command.getInfo()} />;
  }

  return null;
}
